import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { LeafletMap, Maps } from "../../../Constant";
import WorldMap from "./WorldMap";
import USAMap from "./USAMap";
import IndiaMap from "./IndiaMap";
import AustraliaMap from "./AustraliaMap";

const LeafletMapContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={LeafletMap} parent={Maps} title={LeafletMap} />
      <Container fluid>
        <Row>
        <WorldMap />
        <USAMap />
        <IndiaMap />
        <AustraliaMap />
        </Row>
      </Container>
    </>
  )
};

export default LeafletMapContainer;
